export const Logo = ({ className = "h-10 w-10" }) => (
  <svg viewBox="0 0 48 48" className={className} role="img" aria-label="Hyek logo" data-testid="hyek-logo">
    <rect x="2" y="2" width="44" height="44" rx="13" fill="#0F766E" />
    <path d="M14.5 12v24M33.5 12v24" stroke="#FFFFFF" strokeWidth="5" strokeLinecap="round" />
    <path
      d="M24 16.5c3.6 4.3 5.6 7.1 5.6 9.8A5.6 5.6 0 0 1 24 31.9a5.6 5.6 0 0 1-5.6-5.6c0-2.7 2-5.5 5.6-9.8z"
      fill="#99F6E4"
    />
  </svg>
);
